import { render, staticRenderFns } from "./CourseSEO.vue?vue&type=template&id=5fb0a0ea&scoped=true"
import script from "./CourseSEO.vue?vue&type=script&lang=js"
export * from "./CourseSEO.vue?vue&type=script&lang=js"
import style0 from "./CourseSEO.vue?vue&type=style&index=0&id=5fb0a0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0a0ea",
  null
  
)

export default component.exports